import { onboardingFactsSchema, onboardingPlanSchema } from "../start/onboarding-plan.js";
import { z } from "zod/v4";
//#region src/schemas/agent-view/setup-plan.ts
const SETUP_PLAN_AGENT_VIEW_SCHEMA_VERSION = 1;
const SETUP_PLAN_AGENT_VIEW_CODE = "setup.plan";
const setupPlanAgentViewPayloadSchema = z.strictObject({
	schemaVersion: z.literal(1),
	readOnly: z.boolean(),
	facts: onboardingFactsSchema,
	plan: onboardingPlanSchema
});
const setupPlanAgentViewEventSchema = z.strictObject({
	type: z.literal("result"),
	code: z.literal(SETUP_PLAN_AGENT_VIEW_CODE),
	payload: setupPlanAgentViewPayloadSchema
});
//#endregion
export { SETUP_PLAN_AGENT_VIEW_CODE, SETUP_PLAN_AGENT_VIEW_SCHEMA_VERSION, setupPlanAgentViewEventSchema, setupPlanAgentViewPayloadSchema };

//# sourceMappingURL=setup-plan.js.map